/**
 * Core limits shared by document, format, and (future) UI layers.
 * Values mirror the documented Godot behavior (README.md / main.gd).
 */

/** Canvas edges: width and height are each between MIN_DIMENSION and MAX_DIMENSION. */
export const MIN_DIMENSION = 1;
export const MAX_DIMENSION = 128;

/**
 * Hard cap for any parsed input (pixel array / text grid) before it can ever
 * touch a PixelDocument. Chosen so a 128×128 grid always fits with headroom.
 */
export const MAX_INPUT_CELLS = MAX_DIMENSION * MAX_DIMENSION; // 16384

/**
 * Hard cap for any raw text/file content entering the parsers, enforced
 * before JSON.parse or line splitting (DoS guard for imported files and
 * pasted text). Sized for the largest valid inputs with headroom:
 *  - versioned Pixelwerkstatt JSON: width/height 128 → "data" holds
 *    65536 channel numbers of up to 3 digits plus separators ≈ 263k chars
 *  - legacy JSON: 128 rows × 128 cells × up to 8 chars ("#RRGGBB,") ≈ 131k chars
 *  - hex-grid text: 128 rows × 128 cells × up to 8 chars ≈ 131k chars
 * 1 MiB comfortably bounds all of them; the UI lane uses this constant as a
 * FileReader preflight limit before handing content to the core parsers.
 */
export const MAX_TEXT_LENGTH = 1_048_576;

/** Legacy hex strings are exactly "#RRGGBB". */
export const HEX_LENGTH = 7;

/** Editor history: one committed action = one undo step, at most 50 kept. */
export const HISTORY_LIMIT = 50;
